module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "line-height": "32px"
    }
  }, [_vm._v("\n    Reports for:\n    "), _c('select', {
    staticClass: "select input",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "name": "company-select"
    },
    on: {
      "change": _vm.setReportCompany
    }
  }, [_c('option', {
    attrs: {
      "value": "none"
    }
  }, [_vm._v("All Companies")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CF"
    },
    domProps: {
      "selected": _vm.reportCompany === 'CF'
    }
  }, [_vm._v("Crockett Farms Only")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BELLS"
    },
    domProps: {
      "selected": _vm.reportCompany === 'BELLS'
    }
  }, [_vm._v("Bell's Farm Only")])]), _vm._v("\n    between\n    "), _c('input', {
    staticClass: "input",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "type": "date",
      "name": "report-start"
    },
    domProps: {
      "value": _vm.reportStartDate
    },
    on: {
      "input": _vm.setReportStart
    }
  }), _vm._v("\n    and\n    "), _c('input', {
    staticClass: "input",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "type": "date",
      "name": "report-start"
    },
    domProps: {
      "value": _vm.reportEndDate
    },
    on: {
      "input": _vm.setReportEnd
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7c65424"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/reports/ReportSettings.vue
// module id = 582
// module chunks = 0